import RestClient from '../rest_client/rest_client';
import * as LocalStorageUtils from '../utils/local_storage_utils';
import { HOST_NAME_API } from '../../../../shared/serverInfo'

const ROUTE = `${HOST_NAME_API}/form/allowedOrigins`;
const ERROR_MESSAGE = 'Could not get allowed origins on server';
const ALLOWED_ORIGINS_CACHE_KEY = 'allowedOrigins';

function setInLocalStorageAllowedOrigins(response) {
	LocalStorageUtils.setInStorage(ALLOWED_ORIGINS_CACHE_KEY, response.entity);
	return response.entity;
}

function performLoadAllowedOrigins() {
	return RestClient
		.get(ROUTE)
		.then(setInLocalStorageAllowedOrigins)
		.catch(error => console.error(ERROR_MESSAGE, error));
}

export function getAllowedOrigins() {
	return LocalStorageUtils
		.getInStorage(ALLOWED_ORIGINS_CACHE_KEY)
		.catch(performLoadAllowedOrigins);
}
